import React from 'react';
import { Button } from 'reactstrap';

interface EnableDuoButtonProps {
	setActivated: (activated: boolean) => void;
}

/**
 * Enable Duo 2FA provider button
 */
export default function EnableDuoButton(props: EnableDuoButtonProps) {
	return (
		<>
			<Button
				color="primary"
				onClick={() => {
					props.setActivated(true);
					window.location.href = '/duo-setup';
				}}
			>
				Add Duo authenticator
			</Button>
		</>
	);
}
